import { render, staticRenderFns } from "./TencentAiRoiRules.vue?vue&type=template&id=3753605e&scoped=true&"
import script from "./TencentAiRoiRules.vue?vue&type=script&lang=js&"
export * from "./TencentAiRoiRules.vue?vue&type=script&lang=js&"
import style0 from "./TencentAiRoiRules.vue?vue&type=style&index=0&id=3753605e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3753605e",
  null
  
)

export default component.exports